import React from 'react';

interface ChartFooterProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Reusable footer component for charts with consistent styling
 * Provides standard footer layout with centered content
 */
export const ChartFooter: React.FC<ChartFooterProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center gap-2 p-4 text-sm ${className}`}
    >
      <div className="text-gray-700">{children}</div>
    </div>
  );
};
